import {
  createContext,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import styles from "./section-sidebar.module.scss";

export interface SectionSidebar {
  open: () => void;
  close: () => void;
}

export const SidebarContext = createContext({
  open: () => {
    // Void
  },
  close: () => {
    // Void
  },
});

export interface SectionSidebarProps {
  children?: React.ReactNode;
}

export const SectionSidebar = forwardRef<SectionSidebar, SectionSidebarProps>(
  ({ children }, ref) => {
    const [active, setActive] = useState(false);
    const sectionRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (!sectionRef.current) return;

      function onClick(ev: MouseEvent) {
        const target = ev.target as HTMLElement | null;
        if (!target) return;
        // When clicking on a link close the sidebar
        if (target.tagName === "A") {
          setActive(false);
        }
      }
      sectionRef.current.addEventListener("click", onClick);

      return () => sectionRef.current?.removeEventListener("click", onClick);
    }, []);

    useImperativeHandle(ref, () => ({
      open: () => setActive(true),
      close: () => setActive(false),
    }));

    return (
      <>
        <nav data-active={active} className={styles.sidebar} ref={sectionRef}>
          {children}
          <div className={styles.backdrop} onClick={() => setActive(false)} />
        </nav>
      </>
    );
  }
);
